import { ApiService } from "./apiService";

export const SettingsService =()=> {

    return {
        getParams:async()=>{
            const response = await ApiService.get('/api/items/settings?fields=maintenance_mode');
            return response.data;
        }
    }
}
